<template>
  <ErrorPane :errorText="'Erreur 404 : cette page n\'existe pas.'"></ErrorPane>
</template>

<script>
import ErrorPane from '@Components/Error/ErrorPane';

export default {
  components: {
    ErrorPane,
  },
};
</script>
